import React, { useEffect, useState } from 'react';
import axios from 'axios';
import FadeInSection from '../components/FadeInSection';
import PageBanner from '../components/PageBanner';
import { useCms } from '../context/CmsContext';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const Galerij = () => {
  const { img } = useCms();
  const [galerij, setGalerij] = useState([]);
  const [filteredGalerij, setFilteredGalerij] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('Alle');
  const [loading, setLoading] = useState(true);

  const categories = ['Alle', 'Bruiloften', 'Bedrijfsfeesten', 'Festivals', 'Cocktails'];

  const eventImages = [
    'https://images.unsplash.com/photo-1717501787981-d5f28eb2df5f?w=800&q=80',
    'https://images.unsplash.com/photo-1631012202313-32a77a595004?w=800&q=80',
    'https://images.unsplash.com/photo-1739295193536-34334bb15e35?w=800&q=80',
    'https://images.unsplash.com/photo-1733348924351-8b9297bfa51c?w=800&q=80',
    'https://images.unsplash.com/photo-1772661515640-0f205cbf6796?w=800&q=80',
    'https://images.unsplash.com/photo-1758552013326-01b93dd12c3e?w=800&q=80'
  ];

  useEffect(() => {
    const fetchGalerij = async () => {
      try {
        const res = await axios.get(`${API_URL}/api/galerij`);
        setGalerij(res.data);
        setFilteredGalerij(res.data);
      } catch {
        // Silent fail
      } finally {
        setLoading(false);
      }
    };
    fetchGalerij();
  }, []);

  useEffect(() => {
    if (selectedCategory === 'Alle') {
      setFilteredGalerij(galerij);
    } else {
      setFilteredGalerij(galerij.filter(g => g.categorie === selectedCategory));
    }
  }, [selectedCategory, galerij]);

  return (
    <div>
      <PageBanner
        image={img('banner.galerij')}
        title="Galerij"
        subtitle="Impressies van onze cocktailbars en evenementen"
      />

      {/* Filter */}
      <section className="bg-white sticky top-20 z-40 shadow-md">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex flex-wrap gap-3 justify-center">
            {categories.map((cat) => (
              <button
                key={cat}
                onClick={() => setSelectedCategory(cat)}
                className={`px-6 py-2 rounded-full font-semibold transition-all duration-300 ${
                  selectedCategory === cat
                    ? 'bg-[#13498f] text-white shadow-summer'
                    : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                }`}
              >
                {cat}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Galerij Grid */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {loading ? (
          <div className="text-center py-20">Loading...</div>
        ) : (
          <FadeInSection>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredGalerij.map((item, idx) => (
              <div key={item.id} className="group relative overflow-hidden rounded-lg shadow-summer hover:shadow-xl transition-all duration-300">
                <img
                  src={item.afbeelding || eventImages[idx % eventImages.length]}
                  alt={item.titel}
                  className="w-full h-80 object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                    <h3 className="text-2xl font-bold mb-2">{item.titel}</h3>
                    {item.beschrijving && (
                      <p className="text-sm">{item.beschrijving}</p>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
          </FadeInSection>
        )}
      </section>
    </div>
  );
};

export default Galerij;